import { Input } from 'lift-ui';
import React from 'react';

import { AlertFormData } from '../types';

interface BasicInformationStepProps {
  formData: AlertFormData;
  onInputChange: (field: keyof AlertFormData, value: string | number) => void;
  isEditMode?: boolean;
}

export const BasicInformationStep: React.FC<BasicInformationStepProps> = ({
  formData,
  onInputChange,
  isEditMode = false,
}) => {
  return (
    <div
      className="bg-white rounded-lg p-6 space-y-6 border border-black/20 flex flex-col"
      style={{ minHeight: 'calc(90vh - 7rem)' }}
    >
      <div className="max-w-md w-full">
        <label className="text-sm font-medium text-gray-700 mb-2 block text-left">Email Id</label>
        <Input
          value={formData.emailId}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onInputChange('emailId', e.target.value)
          }
          placeholder="Enter email address"
          className="w-full"
          readOnly
          disabled
        />
      </div>

      <div className="max-w-md w-full">
        <label className="text-sm font-medium text-gray-700 mb-2 block text-left">
          Alert Name <span className="text-red-900">*</span>
        </label>
        <Input
          value={formData.alertName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onInputChange('alertName', e.target.value)
          }
          placeholder="Enter alert name"
          className="w-full"
          disabled={isEditMode}
          readOnly={isEditMode}
        />
      </div>

      <div className="max-w-md w-full">
        <label className="text-sm font-medium text-gray-700 mb-2 block text-left">
          Description <span className="text-red-900">*</span>
        </label>
        <textarea
          value={formData.description}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
            onInputChange('description', e.target.value)
          }
          placeholder="Enter description"
          className="w-full min-h-24 px-3 py-2 border border-gray-300 rounded-md focus:outline-none resize-none text-sm"
          rows={4}
        />
      </div>
    </div>
  );
};
